import { pipe, split, path } from 'ramda';

import translations from '../constants/translations';

export default function t(key, def = '') {
  const pathString = pipe(Array.isArray(key) ? key : split(/[[\].]/), path);

  return pathString(key)(translations) || def;
}
